'use strict';

export default class Form {
  constructor() {
    let checkbox = $('.checkbox');
    let radio = $('.radio');

    checkbox.addClass('js-checkbox');
    $('.checkbox label').append("<span class='checkbox__icon'></span>")

    radio.addClass('js-radio');
    $('.radio label').append("<span class='radio__icon'></span>")

  }
}
